import React from 'react';
import { Calendar, Coffee, Shield } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useTranslation } from 'react-i18next';

const eventIcons = {
  1: Calendar,
  2: Coffee,
  3: Shield
};

const Events = () => {
  const { t } = useTranslation();

  const events = [
    { id: 1, key: 'journey' },
    { id: 2, key: 'sensory' },
    { id: 3, key: 'sipat' }
  ];

  return (
    <section id="events" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4">
            {t('events.badge')}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('events.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('events.subtitle')}
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {events.map((event) => {
            const IconComponent = eventIcons[event.id];
            return (
              <Card
                key={event.id}
                className="border-2 border-gray-200 hover:border-teal-400 hover:shadow-lg transition-all duration-300"
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                    <IconComponent className="text-teal-600" size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {t(`events.items.${event.key}.title`)}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {t(`events.items.${event.key}.description`)}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://images.unsplash.com/photo-1765438863717-49fca900f861?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHRyYWluaW5nJTIwd29ya3Nob3B8ZW58MHx8fHwxNzc1MjU0MjEyfDA&ixlib=rb-4.1.0&q=85"
            alt="Eventos e Treinamentos"
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-teal-900/80 to-transparent flex items-center">
            <div className="container mx-auto px-4">
              <div className="max-w-lg text-white">
                <h3 className="text-3xl font-bold mb-4">
                  {t('events.bannerTitle')}
                </h3>
                <p className="text-lg mb-6">
                  {t('events.bannerText')}
                </p>
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="bg-white text-teal-600 hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
                >
                  {t('events.bannerCta')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;
